module.exports = __webpack_public_path__ + "img/clickIcon.a173699f.svg";